import React, { Component } from "react";
import { i18n } from '../../translate/i18n';
import Dropzone from "react-dropzone";
import CheckCircle from "@mui/icons-material/CheckCircle";
import PhotoIcon from '@mui/icons-material/CameraAlt';

import {
  DropContainer,
  UploadMessage,
  UploadMessageUnder,
  Preview
} from "./styles";
import { makeStyles } from "@mui/styles";

const iconStyles = () => {
  return {
    circle: {
      color: "#78e5d5"
    }
  };
};

const styles = {
  editPhotoContainer: {
    position: 'absolute',
    display: 'flex',
    bottom: 23,
    right: 10,
    height: 35,
    width: 35,
    background: '#E4E6EB',
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
  },
  editPhotoIcon : {
    color: 'rgba(0, 0, 0, 0.54)',
  },
};

export default class PhotoUpload extends Component {
  renderDragMessage = (isDragActive, isDragReject) => {
    if (!isDragActive) {
      return (
        <div style={{ padding: "10px" }}>
          <UploadMessage>{i18n.t('uploadMessagePhotoUp.click')}</UploadMessage>
          <UploadMessageUnder>(.jpeg, .jpg, .png, .gif)</UploadMessageUnder>
        </div>
      );
    }

    if (isDragReject) {
      return (
        <div style={{ padding: "10px" }}>
          <UploadMessage type="error">{i18n.t('uploadMessagePhotoUp.error')}</UploadMessage>
          <UploadMessageUnder>(.jpeg, .jpg, .png, .gif)</UploadMessageUnder>
        </div>
      );
    }

    return (
      <div style={{ padding: "10px" }}>
        <UploadMessage type="success">{i18n.t('uploadMessagePhotoUp.success')}</UploadMessage>
        <UploadMessageUnder>(.jpeg, .jpg, .png, .gif)</UploadMessageUnder>
      </div>
    );
  };

  photoPreview = (photo, rounded)=> {
    const classes = makeStyles(iconStyles)();

    return (
      photo.length > 0 && photo[0] && (
        <div style={{ width: '195px', height: '190px', position: 'relative' }}>
          <Preview src={photo[0].preview ? photo[0].preview : photo[0].url} rounded={rounded} />
          {photo[0].uploaded && (
            <div style={{ position: "absolute", bottom: "10px", right: "10px" }}>
              <CheckCircle className={classes.circle} />
            </div>
          )}
        </div>
      )
    );
  };

  render() {
    const { onUpload, photo, enabled, style, fullWidth, rounded, editIcon } = this.props;

    return (
      <Dropzone
        accept="image/*"
        multiple={false}
        onDropAccepted={onUpload}
        disabled={!enabled}
      >
        {({ getRootProps, getInputProps, isDragActive, isDragReject }) => (
          <DropContainer
            style={{ width: fullWidth ? '100%' : '200px' }}
            {...getRootProps()}
            isDragActive={isDragActive}
            isDragReject={isDragReject}
            disabled={!enabled}
            rounded={rounded}
            noBorder={rounded && photo && photo.length > 0}
          >
            <input {...getInputProps()} />
            {photo && this.photoPreview(photo, rounded)}
            {photo.length === 0 &&
              this.renderDragMessage(isDragActive, isDragReject)}
            {editIcon && <div style={styles.editPhotoContainer}>
              <PhotoIcon style={styles.editPhotoIcon} />
            </div>}
          </DropContainer>
        )}
      </Dropzone>
    );
  }
}
